module.exports = __webpack_public_path__ + "static/media/add.87a11216.svg";